/* eslint-disable array-bracket-spacing */
import {
    Component, HostListener, OnInit
} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CfAlertService } from '@crediblefinance/credible-ui';
import {
    ActivatedRoute, Router
} from '@angular/router';
import { getWindow } from 'ssr-window';
import { LocalStorageService } from '../../services/localstorage.service';
import { isPlatformBrowser } from '@angular/common';
import IPrivateCreditPool from '../../interfaces/IPrivateCreditPool';

@Component({
    selector: 'app-lend-v2',
    templateUrl: './lend-v2.component.html',
    styleUrl: './lend-v2.component.scss'
})
export class LendV2Component implements OnInit {
    loading: boolean = true;
    pools: Array<any> = [];
    window: Window;
    payfi_vault_pools: Array<IPrivateCreditPool> = [];
    permissioned_pools: Array<IPrivateCreditPool> = [];

    platformId: object = {};
    tvl_usd = 0;
    outstanding_drawdown_usd = 0;
    isBrowser: boolean = isPlatformBrowser(this.platformId);
    width: any;

    currentTab = 'all';
    tabs = [{
        name: 'All',
        key: 'all'
    }];

    category_id: string = '';
    mobile_layout: any;

    constructor(
        public httpService: HttpService,
        private cfAlertService: CfAlertService,
        private router: Router,
        private route: ActivatedRoute,
        private localStorageService: LocalStorageService) {
        this.window = getWindow();
    }

    ngOnInit(): void {
        console.log('lend.component.ts ngOnInit()');
        this.width = this.window.outerWidth;
        this.getCategories();
        this.getPools();

        if (this.width < 768)
            this.mobile_layout = 'grid';
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.width = event.target.outerWidth;

        console.log('width on resize', this.width);
    }

    getCategories() {
        this.httpService.getCategories().subscribe(res => {
            res.data.forEach((item: any) => {
                this.tabs.push({
                    name: item.name,
                    key: item.category_id
                });
            });
        }, (err: HttpErrorResponse) => {
            console.error(err);

            this.cfAlertService.showError(err);
        });
    }

    getPools() {
        const data = {
            category_id: this.category_id
        };

        this.httpService.getPools(data).subscribe(res => {
            const data = res.data;

            this.pools = data;
            this.payfi_vault_pools = [];

            this.pools.forEach(x => {
                if (x.category_id === 'vault')
                    this.payfi_vault_pools.push(x);

                if (x.category_id === 'private-credit' || x.category_id === 'partner-protocol')
                    this.permissioned_pools.push(x);

                this.tvl_usd += x.stats.tvl_usd;
                this.outstanding_drawdown_usd += x.stats.outstanding_drawdown_usd;
            });

            this.loading = false;
        }, (err: HttpErrorResponse) => {
            console.error(err);

            this.loading = false;

            this.cfAlertService.showError(err);
        });
    }

    getPoolProgressPercent(pool: any) {
        const percentage = (pool.stats.tvl / pool.pool_size_usd) * 100;

        return `${Math.min(percentage, 100)}%`;
    }

    getPoolEarning(item: any) {
        return item.lending_yield_rates[0].apy;
    }

    selectPool(pool: any) {
        console.log('pool', pool);

        this.router.navigate([`/lend/${pool.category_id}/${pool.pool_id}`]);
    }

    redirectToUrl(url: string, event: Event) {
        this.window.open(url, '_blank');

        event.preventDefault();
        event.stopImmediatePropagation();
    }
}